module.exports = __webpack_public_path__ + "static/media/placeholder-image.09b77349.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/placeholder-image.jpg
// module id = 687
// module chunks = 0